export const cardWidthMap = {
  LG: 300,
  MD: 230,
  SM: 160,
};
